'use client';

// Detects whether the current client is a bot/crawler so we can suppress
// behavior that would otherwise leak crawl-burning URLs — notably Next.js
// App Router's <Link> prefetch, which appends `?_rsc=<hash>` query params
// Googlebot then discovers and indexes as duplicates of their canonical pages.
//
// Default state is `true` so SSR-rendered HTML is cache-safe (identical for
// bots and users) and prefetch stays off until the client confirms otherwise.
// After hydration, the actual UA is checked once and cached at module scope
// so subsequent components reuse the result instead of re-running detection.

import { isbot } from 'isbot';
import { useEffect, useState } from 'react';

let cached: boolean | undefined;

export const useIsBot = (): boolean => {
  const [isBot, setIsBot] = useState<boolean>(cached ?? true);

  useEffect(() => {
    if (cached === undefined) {
      cached = isbot(navigator.userAgent);
    }
    if (cached !== isBot) {
      setIsBot(cached);
    }
  }, [isBot]);

  return isBot;
};
